import styled, {css} from 'styled-components'

export const StyledInfoBanner = styled.div(
    ({theme: {spacing, palette, typography}}) => css`
        ${typography.textSm};
        display: flex;
        gap: ${spacing * 2}px;
        padding: ${spacing * 3}px;
        border-radius: 8px;
        background: ${palette.primary[50]};
        border: 1px solid ${palette.primary[200]};
    `
)
